import { Injectable, isDevMode } from '@angular/core';
import { RulesTurnsDaoService } from 'src/app/dao/turns-dao-services/rules-turns-dao-service/rules-turns-dao.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { map, filter, tap } from 'rxjs/internal/operators';
import { UserService } from '../../user-service/user.service';
import { Rule } from 'src/app/models/turns-models/rules.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RulesTurnsService {

  accessToken = 'TUR';
  refreshRulesListener = new Subject<any>();

  constructor(private rulesTurnsDaoService: RulesTurnsDaoService,
              private userService: UserService,
              private userStorageService: UserStorageService) { }

  public getRules(centerInternalId) {
    const internalIdList = [centerInternalId];
    return this.rulesTurnsDaoService.getRules(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalIdList).pipe(
      filter(o => this.userService.accessGranted(this.accessToken)),
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        const rules = new Array<Rule>();
        o['data']['rules'].forEach(r => {
          const rule = new Rule();
          Object.assign(rule, r);
          rules.push(rule);
        });
        return rules.sort((a, b) => a.RuleOrder > b.RuleOrder ? 1 : -1);
      })
    );
  }

  public getRuleActions() {
    return this.rulesTurnsDaoService.getRuleActions(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      filter(o => this.userService.accessGranted(this.accessToken)),
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o['data'])
    );
  }

  public addRule(form) {
    return this.rulesTurnsDaoService.addRule(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), form.get('selectedCenter').value.InternalId, form.get('selectedDesk').value.InternalId, form.get('ruleAction').value, form.get('ruleOperator').value.InternalId, form.get('ruleValue').value, form.get('ruleOrder').value).pipe(
      map(o => o)
    );
  }

  public updateRule(rule, form) {
    return this.rulesTurnsDaoService.updateRule(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), rule.InternalId, rule.RuleOrder, form.get('ruleAction').value.InternalId, form.get('ruleOperator').value.InternalId, form.get('ruleValue').value, rule.CenterInternalId, form.get('selectedDesk').value.InternalId).pipe(
      map(o => o)
    );
  }

  public updateRulesOrder(rules) {
    return this.rulesTurnsDaoService.updateRulesOrder(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), rules).pipe(
      map(o => o)
    );
  }

  public deleteRule(internalId) {
    return this.rulesTurnsDaoService.deleteRule(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
      map(o => o)
    );
  }

  public listenRefreshRules() {
    return this.refreshRulesListener.asObservable();
  }

  public refreshRules() {
    this.refreshRulesListener.next();
  }
}
